function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { Constants } from '../../utils/constants';
class DisclaimerModal extends SpzaComponent {
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "disclaimer is now open",
            className: "disclaimerModalClass",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "prompContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: this.props.payload.title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: this.props.payload.description
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "footer",
                        children: /*#__PURE__*/ _jsx("button", {
                            name: "button",
                            className: "c-button requestButton",
                            type: "submit",
                            "data-bi-id": Constants.JsllCTAId.Continue,
                            "data-bi-area": "Disclaimer Dialog",
                            onClick: this.props.dismissModal,
                            children: this.context.loc('Dialog_Continue')
                        })
                    })
                ]
            })
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0);
    }
}
export { DisclaimerModal as default };
DisclaimerModal.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
